import { Loader } from "@mantine/core";
import classes from "./MapPlaceholder.module.css";

/**
 * Shared by App.tsx's Suspense fallback (while the map chunk downloads) and
 * CampgroundMap's geolocation-pending state (while the initial center
 * resolves). Using one component for both means the handover between them
 * shows no visible seam - just a continuous spinner until the map paints.
 */
const MapPlaceholder = () => (
  <div className={classes.mapPlaceholder}>
    <Loader />
  </div>
);

export default MapPlaceholder;
